module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-no",
    attrs: {
      "id": "ch-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("01 "), _c('img', {
    attrs: {
      "alt": "Book Title of Rewind",
      "src": "images/chap.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("OUR CAR SKIDS TO A STOP AT THE POLICE BARRICADE.")]), _vm._v(" Ross rolls down the window.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Agent Carson Ross.” He holds his badge out to the square-faced cop standing guard. “I have a spinner with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The cop peers past Ross to stare at me with that familiar mix of curiosity and distrust. I pick at a ragged edge on my thumbnail. I hate dealing with people who haven’t met a spinner before. They don’t look at me and think: oh, there’s a sixteen-year-old girl, they look at me and think: ooh, there’s an escaped circus animal. The dangerous kind. That aren’t necessarily fully trained.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The cop hands Ross’s badge back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Chief’s waiting for you.”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("Ross guns the motor and speeds to the open space in front of City Hall. I brace one hand against the glove box to steady myself. Today is the Friday before Labor Day weekend, and this street should be packed. There should be people juggling briefcases and cups of coffee, cell phones chirping, and exotic scents wafting from colorfully painted food carts. Instead, an unnatural emptiness screams "), _c('em', [_vm._v("danger,")]), _vm._v(" the warning underlined by the police cars barricading both ends of ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("the block. Behind them, knots of uniformed men and women huddle, tension emanating from them like a bad smell. The sole person standing on the street is Portland’s chief of police, Lamar Graham.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Ross.” Chief’s lips part in a sigh of relief. “Thank God you’re here.” He bends lower, eyes skipping past me and into the back seat. “You only brought one?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Alex and I were close by when we got the call,” Ross says. “If I’d gone back to the Center, it would have taken twenty minutes. Traffic is nuts out there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Chief checks his watch. A nerve in his jaw twitches.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“How long do we have?” Ross asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Fifteen minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ross climbs from the car. “You called someone from the bomb squad?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Chief shouts a few words in the direction of the huddled officers. I step into the cool fall air, pretending the word "), _c('em', [_vm._v("bomb")]), _vm._v(" doesn’t faze me. Up close, I can see sweat darkening the fabric under Chief’s arms. My already clenching stomach tightens. Chief wants another spinner here because if two of us work together, we can combine our skills and hold the freeze longer. Now it’s all going to be up to me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“That’s McDennon,” Chief says, nodding toward a man striding up the sidewalk. “It’s his first freeze.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("McDennon marches up to Chief and salutes. He’s got a brutal crew cut and is wearing this spotless uniform that makes him look like a character from those Vice War video games the other Center kids play, except for the bag he carries—black, lumpy, and with BOMB SQUAD etched across it in white letters. My mouth fills with spit and I swallow, hard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Let’s get to it,” Ross says.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("I stretch out my arm, exposing the three-inch-wide metal bracelet clasped tight against my left wrist. It looks like those bands Wonder Woman wears in the old cartoons, except mine is called a leash, it’s stamped with the Center’s logo, and I’m required to wear it whenever I leave the building. Ross pulls a key from his pocket and twists it in the band’s lock. The knot in my stomach loosens. Leashes emit a low-level electromagnetic current that, when pressed against a pulse point, blocks my ability to link with time. The instant it falls away, I relax a little. It’s like inhaling a mouthful of fresh air after being cooped up in a stuffy room.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You’d better hurry,” Chief says, taking the leash from Ross. He glances at his watch again. It’s a sporty thing, and even from four feet away, I can read the time: 1:47.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“According to the guy who called it in,” Chief says, “we’re down to thirteen minutes before the bomb blows.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("My stomach twists back into a pretzel. If I can’t hold the freeze long enough for McDennon to find the bomb "), _c('em', [_vm._v("and")]), _vm._v(" figure out how to dismantle it, then City Hall is toast. There isn’t time for another spinner to get here and try again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Don’t worry,” Ross says. “Alex has never failed a mission yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Chief doesn’t look comforted, but Ross’s faith helps restore some of my confidence. I roll the tension from my shoulders and hold out my hands. Ross grasps my right one, and McDennon slides a damp palm around my left. I breathe slowly, the way Ross told me to do when I feel anxious.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You ready?” Ross asks me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I look into his eyes. They’re blue with flecks of darker color in them, like waves in a picture I once saw of the ocean. I take another breath. Release it.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("And then I freeze time.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Everything stops. Sound disappears. The bright September air grows perfectly still. People turn to statues. A clutch of fall leaves, caught in a passing gust of wind, hovers a few inches above the pavement. In the sky over City Hall, a flag hangs in a half-furled wave. Nothing—not a person, insect, machine, or object—moves anywhere in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Nothing, that is, except me and the two people whose skin I’m touching.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("McDennon’s hand twitches in mine. He’s gawking at all the strangeness: a squirrel suspended mid-jump between two trees, tail bristled by a breeze that no longer exists; the fact that our shadows won’t follow us since we can’t block an unmoving ray of light; the impossible, absolute silence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("My breathing steadies; it’s calm, no longer forced. The frozen quiet laps me like a warm bath. It’s not just lack of noise. It’s the absence of sound. Pure. Undisturbed. For the first time since I got out of the car, my body relaxes. This is my element. A freeze is the one place where I am in control. I release the two men’s hands.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Let’s head in,” I say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("McDennon doesn’t move. Instead, he bends to pick up one of the floating leaves and rips it into pieces. When he opens his hand, the shreds flutter to the ground like confetti.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“We need to get going,” Ross says. “Alex can only hold time for about half an hour when she’s dragging along two other people.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("McDennon makes an obvious effort to regain his focus. He straightens, dusting the leaf scraps off his palms.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“The briefing notes said the security cameras caught a suspect leaving the building at the west entrance. We’ll start there.”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Inside, City Hall radiates abandonment. The building is designed with an open lobby that soars all the way to a skylight three stories above. To the left and right, stairs lead to the upper levels. There are no people. We cross the open space and head down a hall to the right.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Everyone must have left the building quickly. Doors hang ajar on either side of the hall. I catch a glimpse of jackets drooping on the backs of chairs, coffee cups forsaken on window ledges, pens dropped on top of half-finished notes. Every desk we pass holds a lit computer screen, and for a second I wish we weren’t walking quite so quickly. I am always curious to see how Norms spend their days.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The west entrance lies at the bend of a stairway leading down into the basement. It’s a solid door with glass on the upper half and a sign saying "), _c('em', [_vm._v("Exit Only.")]), _vm._v(" A security camera hangs over the top molding, its green light shining dully through the still air. I stop on the landing, facing the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ross waves a hand in my direction. “It’s your show.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I nod. McDennon switches his attention from the door to me. I smooth a stray strand of hair into my ponytail.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“How long ago did the suspect leave?” I ask Ross.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He glances at his watch. The hands, of course, haven’t moved since the freeze. He flicks its metal casing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“The camera caught him at 12:25. It was almost 1:50 when you froze, so you’ll need to rewind a bit less than an hour and a half.”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("I close my eyes. In my mind, I picture time as strands woven in the air. Usually the strands slide by freely. During a freeze, they hang still, like fiber stretched across a loom. Mentally, I tighten my grip and pull the strands toward me. Time shifts backward, a gently rocking current that flows through my body. I pull harder, gathering momentum so the minutes rush by fast enough that the ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("hour and a half will pass quickly, but not so fast that we can’t see what’s happening. The rewind settles into a smooth rhythm and I open my eyes.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Shadows flicker along the stairwell, light fading and brightening to match the rapidly altering pattern of sun and clouds outside the window. The air is filled with a whispering hum, a combination of all the background noises so easily ignored in real time: distant voices, the drone of a heater, the faint buzz of electricity. To me it sounds like white noise. Ross describes the sound as an overlarge mosquito lodged in his brain. He says it’s doubly irritating since everyday noises like a sneeze or a clap get unrecognizably distorted when heard speeded up and backward.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("McDennon pulls on his ear. Ross watches the closed door, tapping the handrail with one finger. I sit down and write my name in the dust on the edge of the step. "), _c('em', [_vm._v("Alexandra Manning.")]), _vm._v(" It’s my own little ritual, a temporary signature on the scene I’ve created.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A maintenance guy zooms up from the basement and flits past us. He’s lugging a bucket and mop, his image as insubstantial as the sounds are hushed. McDennon lurches out of the way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Don’t worry.” Ross slaps the wall next to him. “All you can touch is what was here at the moment of the freeze. That guy’s like a memory. We can’t affect the past at all. All we can do is rewind it and see what happened.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("McDennon rubs a hand through his crew cut. I let more time slip past. The strands move through me more sluggishly than usual. A time headache has already woken up in my temple and I’m extra aware of the draining sensation from dragging along two Norms. Probably stress from the bomb. Despite the comfort of the freeze, there’s a tightness in my stomach that hasn’t completely gone away.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("“How are things at the Sick this week?” Ross asks.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("McDennon tugs his ear again. “I beg your pardon?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“He’s talking to me,” I say. I point to my shirt. It’s part of the uniform I always wear when I go out on a mission: khaki pants and a collared maroon shirt embroidered with the words "), _c('em', [_vm._v("Crime Investigation Center, Northwest Division.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“The C-I-C,” I tell him. “Pronounced phonetically it’s "), _c('em', [_vm._v("Sick.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I see.” McDennon doesn’t sound like he does. “And are things good there?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I consider telling him that when the highlight of your week is rewinding violent crimes, it’s generally not considered a sign of a happy home. I refrain. My life isn’t this man’s business.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Stop!” Ross calls.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I pull on the mental strands to halt the flow of the rewind. Superimposed over the closed west door, a shadow door stands open, revealing the dim figure of a man backing into the building.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Is that him?” Ross asks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("McDennon studies the man carefully. He’s young—I’d guess early twenties. A white guy, average height, wearing jeans and a dark windbreaker zipped up to his chin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Can you rewind it a little farther?” McDennon asks. “Real slow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I do as he asks. The young guy backs all the way in, then pauses with one hand on the door. Tipping his face up toward the security camera, he lifts his other arm and waves a defiant one-finger salute at the glowing green light.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“That’s our suspect.” McDennon shakes his head. “Must be a real whack job. Can we follow him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Absolutely.” Ross pats my shoulder. “Good job, Alex. That was fast.”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("The compliment sends a flush across my cheeks. I raise my chin ")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("and start unreeling events again, this time at a steady pace. The suspect lowers his arm and continues his backward walk into the building. When he heads up the stairs, we follow him.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Rewound images of people fill the hallway. Voices well up, the sounds subdued, and the images ghostly. McDennon stares in fascination as Ross walks right through a group of school children on a tour. We pass a man in a suit yakking unintelligibly on his cell phone, and a woman waving manicured hands as she babbles instructions to a younger man jogging backward at her side. Our suspect shuffles among the shadow people, hands stuffed in his pockets, actively avoiding eye contact. No one pays him any attention. I speed the pace of the rewind, the beat of our footsteps keeping pace with my growing excitement. This is the part of investigations I like best: my own carefully controlled rewind, the emerging certainty we are on the right track.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We trail the suspect up another flight of stairs and down an empty hall. Recessed lights illuminate beige walls, their blankness broken up by framed black-and-white photographs of city landmarks: children playing in the Salmon Street fountain, cherry trees blooming beside the river, the Portlandia statue holding her trident. The doors here are all closed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The suspect stops at a large, blue recycling bin. The bin’s lid pops up into his hand and he reaches out over the yawning interior. A backpack, black and limp, rises up to him. He slides it onto one shoulder, lowers the lid, and then glances around before scuttling to a door marked "), _c('em', [_vm._v("Conference Room 3.")]), _vm._v(" Once there, he reverses into the room, pausing at the threshold to check if anyone is in the hall, then pulling the door shut very slowly. Ross waits until the memory of the door closes before opening the real door. I nearly step on his heel in my eagerness to follow him inside.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("The room is dark. It’s a windowless interior room, the only light bleeding through an opaque glass panel beside the door. Any glow from the hall stops where the door blocked it when I froze time. I squint, and the shadows resolve themselves into a long table surrounded by chairs.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“There he is.” Ross lunges to the right of the conference table and drops to his knees. McDennon and I hurry to join him. My vision has adjusted to the murkiness, and I can make out the suspect sprawled on his back with his head under one of the chairs. Frowning with concentration, he pulls a strip of duct tape off the bottom of the chair and returns it to the roll in his other hand. McDennon’s indrawn breath hisses near my ear.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Bingo,” Ross whispers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I wedge my head under the chair beside Ross to get a better view. A brick-shaped object is stuck to the underside of the seat, mummified with a crisscross of tape. Ross reaches out a hand and fingers the bomb. I shiver. Even in this inert form, the thing oozes threat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I wouldn’t touch that,” McDennon says. I can’t see his face from my position under the chair, but his voice trills with alarm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“No?” Ross winks at me. “What about this?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("With a quick tug, he pulls the tape away, letting the bomb drop to the floor with a loud clunk. McDennon leaps to his feet, tripping over my legs in his rush to get away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Mr. Ross!” I say, smothering a laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ross shoots me a grin, and then says to McDennon, in a perfectly serious voice: “I’m sorry. I didn’t mean to startle you.”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Ross stands to help McDennon back to his feet. I remain on the floor until I can control the giggles tickling my throat. Our suspect’s wraithlike shape hovers next to me, methodically taping the shadow ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("bomb in reverse. When I manage to rub the smile off my face, I stop the rewind.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Frozen silence settles around us as I crawl out from under the chair. Ross picks up the bomb and holds it out to McDennon. The explosives expert approaches it warily. Released from the tape, the bomb is a mess of wires around a square of something that reminds me of modeling clay.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“It’s perfectly safe,” Ross says. “The bomb’s got an electrical trigger, so there’s no way it can go off. Electrical impulses freeze just like everything else. None of it works.” Ross sticks a finger under one of the wires and wiggles it. “Even if it did explode, it wouldn’t hurt us. If Alex lost control, time would melt, and we’d go back to where we started, standing next to Chief, and all in one piece.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("McDennon lifts the bomb from Ross’s hand with admirable resolution. He probably heard all this in training; it’s just the reality of it that rattled him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Let’s take this somewhere there’s better light,” he says. “I need to figure out how to dismantle it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The three of us trek out into the hall. Even the muted brightness of frozen light seems glaring after the dark conference room. Ross opens a door across the hallway to reveal a small office, furnished with a desk, a couple of file cabinets, and a visitor’s chair. A bald man sits behind the desk, fingers raised in the act of typing. The sun streaming through the window makes him appear particularly insubstantial. Dust motes hang like glitter inside his chest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("McDennon places his bomb squad bag on an empty space on the desk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“How much time do I have?” he asks me.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("I focus my attention inward. The current of time is pulling harder ")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("now. It’s still manageable, but I know from experience the pressure will grow.")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Fifteen minutes?” I say. “I can hold it for twenty if you need it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“McDennon, you have ten minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ross’s voice is firm. The bomb expert turns to his work without comment. He must be used to working under deadlines.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I can hold it longer than that,” I say to Ross, softly, so I don’t distract McDennon. “If Mr. McDennon doesn’t figure this out now, they’ll only have thirteen minutes in real time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You worry about your job,” Ross says, “and let McDennon worry about his. Come on, we’ll talk in the hall.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A smile twitches the corners of my lips as I follow him out of the room. Ross is hands-down the best agent on the squad. Don’t get me wrong—he can be as abrupt, demanding, and critical as all the other cops, but Ross, unlike any agent I’ve ever heard of, always shares the details of a case. And not only that, he even asks my opinion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As soon as we’re out in the hall he starts talking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Chief said the person who called it in claimed to be the bomber himself. From what Chief told me about the call, McDennon is right. The guy’s a total whack job.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Why would the bomber report his own crime?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ross shakes his head. “Why would he give the video camera the finger? Clearly, he doesn’t care about getting caught. Either that or he thinks we won’t catch him. In the call he ranted about the ineptitude of the police department. He thinks all cops are crooked and that our reliance on spinners is a perversion of nature.” He glances at me. “Sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I shrug. “That’s nothing new. What else did he say?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“That the reason Sikes has never been caught is because Chief Graham is accepting bribes to cover up his crimes.”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("I lean against the wall. If that part of the call leaks out, it’s not going to go over very well. Sikes is the name the press has given to the city’s most notorious criminal and the police department’s Achilles heel. Ten years in and no one has a clue who the man is or how he manages his operation. Or if he’s even a man. Sikes is blamed for the theft of at least fifty million dollars. He steals from banks, high-end jewelry stores, elegant homes, and flourishing businesses. He leaves no clues and always manages to time the thefts so no one discovers them for at least three days—too late for a spinner to rewind the crime. Although there are a few outliers who call Sikes Robin Hood—even spreading rumors that he gives all his riches to charity—most of the city is furious about the police’s failure to catch him.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Do you think it’s true? That Chief is helping Sikes?” I ask.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You know my opinion,” Ross says. “I don’t know if it goes all the way to the Chief, but there is no way Sikes could have avoided capture all these years without some inside help.”")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("The headache building in my skull throbs. Ross is fanatical about unmasking Sikes. Before he was an agent, Ross was a regular police detective. He and his partner, Salvador Rodriguez, were the main investigators on the Sikes case. One day, when Ross was out with a nasty flu, Sal called him up to say there had been a breakthrough in the case. He’d gotten some new information and now had three likely suspects he wanted to interview. Ross asked him to wait, but Sal was too impatient, so he followed up on the leads by himself. The next day, a Friday, Sal disappeared. On Tuesday, his body was found floating in the Willamette River. Ross swore he’d catch Sikes and make him pay. Instead, Chief sent him on leave for a few months. When he came back, Chief said the case had become too personal for Ross and that it would be better for someone else to handle it. Ross was transferred to ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("the Time Department. He’s supposed to have let the case go, but he still works it on his own. He and I have spent many hours in the car talking through evidence.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“What would the suspect gain by bombing city hall?” I ask Ross.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ross frowns at the floor as if there might be answers in the linoleum’s abstract swirls.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Given that he called it in, I don’t think he planned to actually hurt anyone. Probably just wanted to show how powerful he is. Did you notice the schedule outside the room where he put the bomb? The meeting this afternoon was about the precinct’s budget. Chief would have been there, along with the mayor and lots of upper level staff.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I rub my temple, trying to think like a psycho bomber.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Maybe he really does have information about which cops are working with Sikes. He could have known about the meeting and set the bomb as a warning to them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“If he did have information about Sikes, this kind of attention would not make our master thief very happy.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“There must be a pretty clear image of the guy on videotape. Surely the cops will be able to identify him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ross’s frown deepens. “I wonder …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I know what he’s thinking. If he could get a chance to question the bomber, find out who on the force was working with Sikes, it might give him a lead to crack the case. The pounding in my head bounces up to match the spike in my pulse. All the spinners at the Center tease me about my dedication to time work, but none of them would laugh if I helped solve a case this big.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("“Agent Ross,” McDennon calls. Ross’s head jerks up, and we hurry back into the room. The bomb expert is standing in the middle of the ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("small office, his face split with a Cheshire cat grin. Wires and bits of plastic are strewn all over the desk.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I got it,” he says. He wipes his brow against the shoulder of his shirt. I rub my head, too. Time is pulling at me hard now, a current with definite intentions of dragging me downstream. McDennon starts packing things back into his bomb squad bag. A tiny screwdriver. A magnifying glass.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“There’s no need for that,” Ross says. “Let it go, Alex.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I release my hold on time with relief. The scene around us blurs. Ross told me once that the melt made him momentarily dizzy, like missing a step off a curb. For me, the sensation is more violent. Scenes from the freeze swing crazily in my head: the suspect placing tape, manicured nails waving in a crowded hall, the janitor’s bouncing mop. I try to relax the way we’re trained, to let time wash over me, but it still feels like the seconds are being forcibly ripped through my chest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The world steadies. I am standing on the steps in front of City Hall, staring into Ross’s ocean-blue eyes. He blinks and lets go of my hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Chief starts. “You’re back?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("McDennon’s neatly packed bomb bag slips from his fingers and hits the ground with a thud. The leaf he’d shredded during the freeze, once again intact, floats past his feet on its draft of wind. The squirrel completes its journey to the neighboring tree. The flag on the rooftop flutters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Chief looks up at the building. “Did you find it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Yes, sir,” McDennon answers, scrambling to recover his bag, “and I know how to dismantle it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Quick,” Chief says. “Go.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("McDennon races back up the stairs. Chief turns to Ross and hands over my leash.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("“How long were you inside?” Chief asks him.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’d guess twenty, twenty-five minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ross refastens the leash around my arm. I wish he’d been less prompt. My head is still swimming from releasing the freeze, and adding the leash’s hum makes me queasy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ross walks over to stand next to Chief. Neither man speaks. Chief keeps glancing at his watch, then back up at City Hall. The cops waiting down the street mutter together, the sound echoing the buzz in my head. I want to go over and stand with them, just in case, but the effort is beyond me. Instead, I sit on the steps and lay my head on my knees. Time headaches usually fade after a few minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“All clear, Chief!” McDennon yells.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He bursts through the front door, arms raised as if he’s just won a championship race. When he waves pieces of the bomb, cheers break out from the waiting police. Chief rushes to shake his hand. He’s smiling so widely I catch glimpses of silver on his back teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I stand up and instantly regret it. This is the worst time headache ever. It feels like someone is squeezing the back of my eyeballs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Agent Ross.” Chief is back, one arm draped over McDennon’s shoulders. “You did all right today, you and …” He nods over at me, my name clearly gone from his memory.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The other cops flood around them. They’re laughing and shoving each other, all eager to congratulate the new heroes. I slump back down onto the step, grateful for once to be ignored. If this was the time someone actually came over to thank me, I’d probably puke all over their shoes.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("The steps grow crowded. Nervous sweat taints the air with bitter perfume. People yell, cell phones jangle. The noises bounce around my head like a mistuned orchestra. And it isn’t just the noise, it’s the light, too. Everything around me seems too bright, the edges so sharp ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("they hurt. I put a hand up to shade my eyes and touch clammy skin.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Nausea, fever … Realization thrusts me back to my feet. It’s normal for me to get a headache from freezing. This is different.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Mr. Ross!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I must have shouted. Heads turn, confusion interrupting their celebration. I don’t care. Panic is drowning me in a way time never does.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ross hurries over.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“What is it?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I clutch his proffered hand. “I’m sick.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“A headache?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“No! I’m sick, Mr. Ross. Time sick.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ross’s face crumples.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Come on,” he murmurs, wrapping an arm around my shoulders. “Let’s get you out of here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Where are you going?” Chief calls. “I need you for the press conference. It’s set up for four o’clock.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’ll be there,” Ross says over his shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Don’t worry,” he tells me as he shepherds me to his car. “It’s going to be OK.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I stumble along beside him. I know Ross is lying. Things are not going to be OK. Time, that invisible essence I control with a twist of my mind, always takes its revenge. Once a spinner gets sick, the end is inevitable. A few months, a year at most, and then … Sixteen is young, but not unheard of.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("No spinner lives past twenty.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c1a546b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004_Chapter01.vue
// module id = 66
// module chunks = 0